import DesignTokens from '@tableau/design-tokens';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { imgUrl } from '~src/commonInfra/utils/ImgUrl';
import { applyColor }from '~src/style/ColorService';

import {cssClass} from '../../../style';

const cssPrefix = 'AnalyticsExtensionsSettings';

export namespace AnalyticsExtensionsSettingsStyles {

    export const enableForSite = cssClass(cssPrefix, 'enable-for-site', {
      margin: '10px 0 10px 0',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '610px'
    });

    export const editDialogSectionEDFFOn = cssClass(cssPrefix, 'edit-dialog-section-ed-ff-on', {
      display: 'block',
      padding: '0 18px',
      margin: '0 -18px',
      minWidth: 'max-content'
    });

    export const editDialogTitle = cssClass(cssPrefix, 'edit-dialog-title', {
      display: 'block',
      width: '100%',
      fontSize: CommonStyles.Sizes.HeaderFontSize,
      color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey77),
      marginBottom: CommonStyles.Sizes.LargeSpace,
      padding: [CommonStyles.Sizes.MediumSpace, 0, CommonStyles.Sizes.SmallSpace, CommonStyles.Sizes.MediumSpace],
      backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, CommonStyles.Colors.Grey245)
    });

    export const editDialogDescription = cssClass(cssPrefix, 'edit-dialog-description', {
      display: 'block',
      width: '100%',
      color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey77),
      paddingBottom: CommonStyles.Sizes.LargeSpace,
      paddingLeft: CommonStyles.Sizes.MediumSpace,
      paddingRight: CommonStyles.Sizes.MediumSpace,
      marginRight: CommonStyles.Sizes.MediumSpace
    });

    export const editDialogBlock = cssClass(cssPrefix, 'edit-dialog-block', {
      display: 'block',
      width: '100%',
      paddingBottom: CommonStyles.Sizes.LargeSpace,
      paddingLeft: CommonStyles.Sizes.MediumSpace,
      paddingRight: CommonStyles.Sizes.LargeSpace
    });

    export const editDialogInputBlock = cssClass(cssPrefix, 'edit-dialog-input-block', {
      display: 'block',
      paddingBottom: CommonStyles.Sizes.SmallSpace
    });

    export const editDialogInputInline = cssClass(cssPrefix, 'edit-dialog-input-inline', {
      display: 'inline',
      verticalAlign: 'bottom',
      paddingLeft: CommonStyles.Sizes.LargeSpace,
      paddingBottom: CommonStyles.Sizes.SmallSpace
    });

    export const editDialogProtocolLabel = cssClass(cssPrefix, 'edit-dialog-protocol-label', {
      display: 'inline-block',
      width: '46px'
    });

    export const editDialogTabPyHostInput = cssClass(cssPrefix, 'edit-dialog-tabpy-host-input', {
      $nest: {
        '& input': {
          width: '201px'
        }
      }
    });

    export const editDialogHostInput = cssClass(cssPrefix, 'edit-dialog-host-input', {
      $nest: {
        '& input': {
          width: '265px'
        }
      }
    });

    export const editDialogPortInput = cssClass(cssPrefix, 'edit-dialog-port-input', {
      $nest: {
        '& input': {
          width: '60px'
        }
      }
    });

    export const editDialogUserNameInput = cssClass(cssPrefix, 'edit-dialog-user-name-input', {
      $nest: {
        '& input': {
          width: '162px'
        }
      }
    });

    export const editDialogPasswordInput = cssClass(cssPrefix, 'edit-dialog-password-input', {
      $nest: {
        '& input': {
          width: '162px'
        }
      }
    });

    export const editDialogActions = cssClass(cssPrefix, 'edit-dialog-actions', {
      float: 'right',
      marginBottom: CommonStyles.Sizes.LargeSpace
    });

    export const editDialogCancel = cssClass(cssPrefix, 'edit-dialog-cancel', {
      display: 'inline',
      paddingRight: CommonStyles.Sizes.MediumSpace
    });

    export const editDialogSave = cssClass(cssPrefix, 'edit-dialog-create', {
      display: 'inline',
      paddingRight: CommonStyles.Sizes.LargeSpace,
      marginRight: CommonStyles.Sizes.LargeSpace
    });

    export const connectionSettingsTableEDFFOn = cssClass(cssPrefix, 'connection-settings-table-ed-on', {
      display: 'table',
      width: '610px',
      borderCollapse: 'collapse'
     });

  export const connectionSettingsTableNCFFOn = cssClass(cssPrefix, 'connection-settings-table-nc-on', {
    display: 'table',
    width: '610px',
    float: 'none',
    borderCollapse: 'collapse'
  });

    export const connectionSettingsTableBody = cssClass(cssPrefix, 'onnection-settings-table-body', {
      display: 'table-body',
      width: '100%'
    });

    export const createNewConnectionButton = cssClass(cssPrefix, 'create-new-connection-button', {
      width: '167px',
      height: '24px',
      margin: '19px 220px 41px 223px',
      backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#FFFFFF')
    });

    export const connectionSettingsRow = cssClass(cssPrefix, 'connection-settings-row', {
      display: 'table-row',
      fontWeight: 'bold',
      margin: '4px 0px 4px 0'
    });

    export const connectionSettingsRowEDFFOn = cssClass(cssPrefix, 'connection-settings-row-ed-on', {
      display: 'table-row',
      fontWeight: 'bold',
      margin: '4px 0px 4px 0',
      width:'100%'
    });

    export const connectionSettingsCell = cssClass(cssPrefix, 'connection-setting-cell', {
      display: 'table-cell',
      padding: '0px 5px 0px 5px',
      verticalAlign: 'bottom'
    });

    export const connectionRow = cssClass(cssPrefix, 'connection-settings-row', {
      display: 'table-row',
      margin: '4px 2px 4px 2px',
      width: '100%'
    });

    export const connectionRowEDFFOn = cssClass(cssPrefix, 'connection-settings-row-ed-on', {
      display: 'table-row',
      margin: '4px 2px 4px 2px',
      width: '610px'
    });

  export const connectionRowNCFFOn = cssClass(cssPrefix, 'connection-settings-row-nc-on', {
    display: 'table-row',
    margin: '4px 2px 4px 2px',
    width: '610px'
  });

    export const connectionHeaderCell = cssClass(cssPrefix, 'connection-header-cell', {
      display: 'table-cell',
      borderBottomStyle: 'solid',
      borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
      background: applyColor(DesignTokens.color.elevation.surface.default.default, '#FAFAFA'),
      borderTopStyle: 'solid',
      borderWidth: 'thin',
      fontSize: '13px',
      fontWeight: 'bold',
      padding: '2px 5px 2px 5px',
      verticalAlign: 'bottom'
    });

    export const connectionHeaderCellEDFFOn = cssClass(cssPrefix, 'connection-header-cell-ed-on', {
      display: 'table-cell',
      borderBottomStyle: 'solid',
      borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
      background: applyColor(DesignTokens.color.elevation.surface.default.default, '#FAFAFA'),
      borderTopStyle: 'solid',
      borderWidth: 'thin',
      fontSize: '12px',
      fontWeight: 'bold',
      height: '30px',
      position: 'relative'
    });

  export const connectionHeaderCellNCFFOn = cssClass(cssPrefix, 'connection-header-cell-nc-on', {
    display: 'table-cell',
    borderBottomStyle: 'solid',
    borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    background: applyColor(DesignTokens.color.elevation.surface.default.default, '#FAFAFA'),
    borderTopStyle: 'solid',
    borderWidth: 'thin',
    fontSize: '12px',
    fontWeight: 'bold',
    height: '30px',
    position: 'relative'
  });

  export const connectionHeaderCellLabel = cssClass(cssPrefix, 'connection-header-cell-label', {
    fontWeight: 'bold !important' as 'bold'
  });

    export const connectionCell = cssClass(cssPrefix, 'connection-setting-cell', {
      display: 'table-cell',
      borderBottomStyle: 'solid',
      borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
      borderWidth: 'thin',
      fontWeight: 'normal',
      padding: '2px 5px 2px 5px',
      position: 'relative',
      verticalAlign: 'bottom'
    });

    export const connectionCellEDFFOn = cssClass(cssPrefix, 'connection-cell-ed-on', {
      display: 'table-cell',
      borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
      borderWidth: 'thin',
      fontWeight: 'normal',
      height: '56px',
      position: 'relative',
      verticalAlign: 'middle'
    });

  export const connectionCellNCFFOn = cssClass(cssPrefix, 'connection-cell-nc-on', {
    display: 'table-cell',
    borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    borderWidth: 'thin',
    fontWeight: 'normal',
    height: '56px',
    position: 'relative',
    verticalAlign: 'middle'
  });

    export const connectionCellIconEDFFOn = cssClass(cssPrefix, 'connection-setting-cell-icon-ed-on', {
      display: 'table-cell',
      borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
      borderWidth: 'thin',
      fontWeight: 'normal',
      position: 'relative',
      verticalAlign: 'middle',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat'
    });

  export const connectionCellIconNCFFOn = cssClass(cssPrefix, 'connection-setting-cell-icon-nc-on', {
    display: 'table-cell',
    borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    borderWidth: 'thin',
    fontWeight: 'normal',
    position: 'relative',
    verticalAlign: 'middle',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat'
  });

    export const emptyConnectionPrompt = cssClass(cssPrefix, 'no-connection-prompt', {
      display: 'table-cell',
      borderBottomStyle: 'solid',
      borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
      borderWidth: 'thin',
      fontStyle: 'italic',
      padding: '2px 5px 2px 5px',
      verticalAlign: 'bottom',
      width: '100%'
    });

    export const getNoConnectionIcon = () => cssClass(cssPrefix, 'no-connection-icon', {
      width: '72px',
      height: '72px',
      right: '268px',
      top: '34px',
      margin: '34px 268px 26px 270px',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundImage: imgUrl('extension.svg')
    });

    export const noConnectionTextLabel = cssClass(cssPrefix, 'no-connection-text-label', {
      width: '600px',
      height: '27px',
      margin: '26px 4px 19px 6px',
      textAlign: 'center'
    });

    export const noConnectionText = cssClass(cssPrefix, 'no-connection-text', {
      fontStyle: 'normal',
      fontWeight: 350,
      letterSpacing: '0.2px',
      color: applyColor(DesignTokens.color.font.default.secondary, '#4F4F4F'),
      textAlign: 'center',
      fontSize: 18
    });
    export const Hide = cssClass(cssPrefix, 'connection-setting-checkbox-hidden', {
     display: 'none'
    });

    export const connectionPortInput = cssClass(cssPrefix, 'connection-port-input', {
      $nest: {
        '& input': {
          width: '60px'
        }
      }
    });

    export const connectionSslCheckbox: React.CSSProperties = {
      width: '96px'
    };

    export const connectionDeleteConfirmationDialogHeader = cssClass(cssPrefix, 'connection-delete-confirmation-dialog-header', {
      marginTop: CommonStyles.Sizes.SmallSpace,
      marginBottom: CommonStyles.Sizes.MediumSpace
    });

    export const connectionDeleteConfirmationDialogHeaderContainerEDFFOn = cssClass(cssPrefix, 'connection-delete-confirmation-dialog-header-ed-on', {
      backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, CommonStyles.Colors.Grey245),
      marginTop: 0-CommonStyles.Sizes.MediumSpace,
      marginLeft: 0-CommonStyles.Sizes.LargeSpace,
      marginRight: 0-CommonStyles.Sizes.LargeSpace,
      paddingLeft: '20px',
      height: '30px',
      display: 'flex',
      alignItems: 'center'
    });

    export const connectionDeleteConfirmationDialogHeaderEDFFOn = cssClass(cssPrefix, 'connection-delete-confirmation-dialog-header-ed-on', {
      fontSize: CommonStyles.Sizes.HeaderFontSize,
      fontStyle: 'normal'
    });

    export const connectionDeleteConfirmationDialogDescription = cssClass(cssPrefix, 'connection-delete-confirmation-dialog-description', {
      fontSize: CommonStyles.Sizes.NormalFontSize
    });

    export const getEditConnectionButton = () => cssClass(cssPrefix, 'edit-button', {
      marginLeft: 4,
      minWidth: CommonStyles.Sizes.SmallIconSize,
      height: CommonStyles.Sizes.SmallIconSize,
      verticalAlign: 'middle',
      backgroundColor: 'transparent',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      display: 'inline-block',
      border: 'none',
      backgroundImage: imgUrl('menu_edit.svg')
    });

  export const waitingForConnectionsSpinner = cssClass(cssPrefix, '-spinner', {
    margin: '40px 0 90px',
    width: '610px',
    display: 'flex',
    justifyContent: 'center'
  });
}
